/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from "react";

import axios from "axios";
import { withRouter } from "react-router-dom";
import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import {
  Paper,
  Grid,
  Typography,
  Divider,
  TextField,
  Button,
} from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormLabel from "@material-ui/core/FormLabel";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

import Actions from "../../fluid/Actions/ActionFactory";

import { allowedByOpop } from '../Security/SecureCheck'

const styles = (theme) => ({
  paper: {
    width: "100%",
    padding: "8px",
  },
  text_field: {
    width: "100%",
    marginTop: "10px",
  },
  form_control: {
    width: "100%",
    marginTop: "10px",
  },
});

const blue_theme = createMuiTheme({
  palette: {
    primary: {
      main: "#2296f3",
    },
    // primary: {
    //     main: "#FF6600",
    //     contrastText: "#FFFFFFFF"
    // },
    secondary: {
      main: "#dc014e",
    },
  },
});

class CreateIC extends Component {
  state = {
    ic_name: "",
    ic_name_helper_text: "Use a unique Information Channel name",
    ic_name_error: false,
    ic_type: "",
    ic_type_helper_text: "Select the type of Information Channel",
    ic_type_error: false,
    supported_ops: [],
    operations: [],
    operations_error: false,
    submission: false,
  };

  componentWillMount() {
    Actions("http_request", {
      url: "/sainapse/operations",
      method: "",
      data: {},
    }).then((res) => {
      this.setState({ ...this.state, supported_ops: res.data.result }, () =>
        console.log("Supported Ops: ", this.state.supported_ops)
      );
    });
  }

  handleChange = (event, id) => {
    this.setState(
      {
        ...this.state,
        [id]: event.target.value,
      },
      () => {
        if (id !== "ic_name") {
          this.validateForm();
        }
      }
    );
  };

  hasDependents = (ops_name) => {
    let has_dependents;

    let dependent_index = this.state.supported_ops.findIndex((item) => {
      if (item.dependencies) {
        if (item.dependencies.includes(ops_name)) {
          return true;
        }
      } else {
        return false;
      }
    });

    if (dependent_index === -1) {
      return false;
    } else {
      return true;
    }
  };

  handleOperations = (event) => {
    console.log(event.target.name);
    let ops = [...this.state.operations];
    if (this.state.operations.includes(event.target.name)) {
      ops.splice(
        ops.findIndex((item) => item === event.target.name),
        1
      );

      if (this.hasDependents(event.target.name)) {
        let dependent_op = this.state.supported_ops[
          this.state.supported_ops.findIndex((item) => {
            if (item.dependencies) {
              if (item.dependencies.includes(event.target.name)) {
                return true;
              }
            } else {
              return false;
            }
          })
        ].type;

        ops.splice(
          ops.findIndex((item) => item === dependent_op),
          1
        );
      }
    } else {
      ops.push(event.target.name);
    }

    this.setState(
      {
        ...this.state,
        operations: [...ops],
      },
      () => console.log("Selected Ops :", this.state.operations)
    );
  };

  validateForm = () => {
    console.log("State: ", this.state);
    console.log("Validating");
    let ic_name_error;
    let ic_type_error;
    let operations_error;

    if (!(this.state.ic_name.length > 0)) {
      ic_name_error = true;
    } else {
      ic_name_error = false;
    }

    if (!(this.state.ic_type.length > 0)) {
      ic_type_error = true;
    } else {
      ic_type_error = false;
    }

    if (!(this.state.operations.length > 0)) {
      operations_error = true;
    } else {
      operations_error = false;
    }

    this.setState({
      ...this.state,
      ic_name_error: ic_name_error,
      ic_type_error: ic_type_error,
      operations_error: operations_error,
    });

    if (ic_name_error || ic_type_error || operations_error) {
      return false;
    } else {
      return true;
    }
  };

  submitForm = () => {
    if (this.validateForm()) {
      Actions("http_request", {
        url: "/sainapse/information_channel",
        method: "post",
        data: {
          name: this.state.ic_name,
          type: this.state.ic_type,
          operations: this.state.operations,
        },
      })
        .then((res) => {
          console.log(res);
          this.setState(
            {
              ...this.state,
              name: res.data.result.name,
              submission: true,
            },
            () => {
              this.props.nextStep({
                ic_name: this.state.ic_name,
              });
            }
          );
        })
        .catch((err) => {
          let err_data = err.response.data;
          this.handleError(err_data);
        });
    }
  };

  validateAndSubmit = () => {
    this.validateForm().then(this.submitForm());
  };

  renderCheckBoxes = () => {
    let ops = this.state.supported_ops.map((op) => {
      if (op.dependencies) {
        if (this.state.operations.includes(op.dependencies[0])) {
          return (
            <FormControlLabel
              id = {'op-' + op.annotation}
              style={{ marginLeft: "20px" }}
              control={
                <Checkbox
                  inputProps={{ 'test-id': 'op-' + op.annotation }}
                  checked={
                    this.state.operations.includes(op.type) ? true : false
                  }
                  onChange={this.handleOperations}
                  name={op.type}
                />
              }
              label={op.annotation}
            />
          );
        }
      } else {
        return (
          <FormControlLabel
            control={
              <Checkbox
                checked={this.state.operations.includes(op.type) ? true : false}
                onChange={this.handleOperations}
                name={op.type}
              />
            }
            label={op.annotation}
          />
        );
      }
    });

    return ops;
  };

  goToIcList = () => {
    const { history } = this.props;
    history.push({
      pathname: "/ic",
    });
  };

  handleError = (err_data) => {
    let errors = err_data.errors;

    errors.map((error) => {
      if (error.attribute === "name") {
        this.setState({
          ...this.state,
          ic_name_error: true,
          ic_name_helper_text: error.message,
        });
      } else if (error.attribute === "type") {
        this.setState({
          ...this.state,
          ic_type_error: true,
          ic_type_helper_text: error.message,
        });
      } else if (error.attribute === "operations") {
        this.setState({
          ...this.state,
          operations_error: true,
        });
      }
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <Paper className={classes.paper} elevation={5}>
        <Typography variant="h6">Create Information Channel</Typography>
        <Divider />
        <TextField
          id="new-ic-name"
          className={classes.text_field}
          disabled={this.state.submission}
          name="Information Channel"
          defaultValue=""
          multiline={false}
          label="Information Channel"
          value={this.state.ic_name}
          error={this.state.ic_name_error}
          type="string"
          required={true}
          variant="standard"
          size="small"
          helperText={this.state.ic_name_helper_text}
          onChange={(event) => this.handleChange(event, "ic_name")}
        />
        <FormControl
          className={classes.form_control}
          error={this.state.ic_type_error}
          disabled={this.state.submission}
        >
          <InputLabel id="new-ic-type-label">
            Information Channel Type
          </InputLabel>
          <Select
            labelId = "new-ic-type"
            id = "new-ic-type"
            value={this.state.ic_type}
            onChange={(event) => this.handleChange(event, "ic_type")}
          >
            <MenuItem id = "ic-type-heterogeneous" value="Heterogeneous">Heterogeneous</MenuItem>
            <MenuItem id = "ic-type-homogeneous" value="Homogeneous">Homogeneous</MenuItem>
          </Select>
          <FormHelperText>{this.state.ic_type_helper_text}</FormHelperText>
        </FormControl>
        <FormControl
          className={classes.form_control}
          error={this.state.operations_error}
          disabled={this.state.submission}
        >
          <FormLabel component="legend">
            Select the Operations for this Information Channel
          </FormLabel>
          <FormGroup>
            {/* <FormControlLabel
                                control={<Checkbox checked={this.state.operations.includes('Recommend') ? true : false} onChange={this.handleOperations} name="Recommend" />}
                                label="Recommendation"
                            />
                            <FormControlLabel
                                control={<Checkbox checked={this.state.operations.includes('Classify') ? true : false} onChange={this.handleOperations} name="Classify" />}
                                label="Classification"
                            />
                            <FormControlLabel
                                control={<Checkbox checked={this.state.operations.includes('TopicModel') ? true : false} onChange={this.handleOperations} name="TopicModel" />}
                                label="Topic Modelling"
                            /> */}
            {this.renderCheckBoxes()}
          </FormGroup>
          <FormHelperText>Select at least one operations</FormHelperText>
        </FormControl>
        <ThemeProvider theme={blue_theme}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              marginTop: "10px",
              justifyContent: "space-around",
              alignItems: "center",
            }}
          >
            <Button
              id = "new-ic-create-button"
              style={{
                width: "48%",
              }}
              //fullWidth = {true}
              variant="contained"
              color="primary"
              onClick={this.submitForm}
              disabled = {!allowedByOpop({
                operation : "/sainapse/information_channel",
                method : "POST",
                operands : []
              })}
            >
              Create IC
            </Button>
            <Button
              id = "new-ic-cancel-button"
              style={{
                width: "48%",
                //marginLeft: "8px"
              }}
              color="secondary"
              variant="outlined"
              onClick={this.goToIcList}
            >
              Cancel
            </Button>
          </div>
        </ThemeProvider>
      </Paper>
    );
  }
}

export default withRouter(withStyles(styles)(CreateIC));
